export default "__VITE_ASSET__ie2vaDSL__"